import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button, IconSpinner, StatisticsSection } from '../../../components';
import { selectOwnRiderListings } from '../../../ducks/riderListings.duck';
import { EXTRA_PACKAGES } from '../../../containers/EditUserInfoPage/EditUserInfoPage';
import { createResourceLocatorString } from '../../../util/routes';
import routeConfiguration from '../../../routeConfiguration';
import config from '../../../config';
import StatisticsSectionPackagesInfo from '../../../components/StatisticsSection/StatisticsSectionPackagesInfo.js';
import classNames from 'classnames';
import css from './ExtraPackagesSection.css';

const { userTypeRider } = config;
/**
 * This component is developed only for riders for now
 */
export default ({ currentUser }) => {
    const history = useHistory();

    const currentUserId = currentUser?.id?.uuid;

    /**
     * fetched once per session by middlewares/currentUser.js, read here rather
     * than re-fetched (see riderListings.duck.js:selectOwnRiderListings)
     */
    const [riderListings, loading] = useSelector(state =>
        selectOwnRiderListings(state, currentUserId)
    );

    const riderListing = Array.isArray(riderListings)
        ? riderListings.find(
              ({
                  attributes: {
                      publicData: { userRepresentationId },
                  },
              }) => !!userRepresentationId
          )
        : null;

    if (loading) return <IconSpinner />;

    const navigateToEditPackagesPage = () =>
        history.push(
            createResourceLocatorString(
                'EditUserInfo',
                routeConfiguration(),
                { section: EXTRA_PACKAGES, userType: userTypeRider },
                {}
            )
        );

    return (
        <StatisticsSection currentListing={riderListing} packagesType="profile">
            <StatisticsSectionPackagesInfo
                handlePackageActivation={navigateToEditPackagesPage}
                currentListing={riderListing}
                isUserPackageType
                renderActionButton={({ className }) => (
                    <Button
                        type="button"
                        className={classNames(css.addPackageButton, className)}
                        onClick={navigateToEditPackagesPage}
                    >
                        Zusatzpaket hinzufügen
                    </Button>
                )}
            />
        </StatisticsSection>
    );
};
